// Reglas de desempate del eje Categoría (hoja "Reglas de desempate").
//
// FUENTE ÚNICA DE VERDAD para dos consumidores que el spec §9 exige
// mantener sincronizados:
//   1. el material de capacitación humana —
//      docs/postventa-taxonomy-desempate.md, GENERADO desde este array
//      por `pnpm taxonomy:docs` y verificado por
//      `fitness:taxonomy-docs-sync` (regla nueva aquí = doc nuevo en
//      el mismo commit, o CI falla);
//   2. el prompt del clasificador (ola 3 — el renderer lee este mismo
//      array).
// Editar el doc generado a mano no sirve: la próxima corrida lo pisa.
export const REGLAS_DESEMPATE = [
    {
        id: "DES-01",
        caso: "Filtración en el cielo del baño que despegó la pintura del pasillo",
        etiquetaAmbigua: "TAB-02 (cielo falso) o REV-01 (pintura)",
        categoriaCorrecta: "IMP-07 si el origen es el recinto húmedo del piso superior; INS-03 si es una fuga de alcantarillado. Ubicación = baño / cielo. Tipo de observación = TF-04.",
        porQue: "La pintura es DAÑO DERIVADO: no se registra como observación aparte. Si el origen no es determinable en terreno, marcar categoria_provisional = Sí.",
    },
    {
        id: "DES-02",
        caso: "Mancha de humedad en el zócalo de un dormitorio de primer piso",
        etiquetaAmbigua: "REV-01 (pintura) o PAV",
        categoriaCorrecta: "IMP-08 (impermeabilización de subterráneo o sobrecimiento), con categoria_provisional = Sí.",
        porQue: "El pintor no resuelve humedad ascendente. Provisional hasta diagnóstico.",
    },
    {
        id: "DES-03",
        caso: "Hongos en la esquina de la ducha, sin filtración detectable",
        etiquetaAmbigua: "IMP-07 o REV",
        categoriaCorrecta: "CLI-03 (extracción de baño) si no hay extractor o no opera. Si el extractor opera bien, OTR con categoria_provisional = Sí y texto libre.",
        porQue: "Al eliminarse ENV, la condensación sin causa identificable va a OTR provisional. Es el caso que más va a alimentar la cola de revisión: vigílenlo.",
    },
    {
        id: "DES-04",
        caso: "Piso flotante levantado o abombado",
        etiquetaAmbigua: "PAV-02 (piso flotante)",
        categoriaCorrecta: "PAV-02 sólo si la causa es la instalación. Si hay humedad bajo el piso, la categoría es INS o IMP.",
        porQue: "Preguntar primero: ¿hay agua? Si la hay, el piso es daño derivado.",
    },
    {
        id: "DES-05",
        caso: "Filtración por la ventana cuando llueve con viento",
        etiquetaAmbigua: "PVE-06 (sello perimetral) o IMP",
        categoriaCorrecta: "PVE-06 si falla el sello o el marco de la ventana; IMP-09 si falla el encuentro de la ventana con la fachada.",
        porQue: "Distinción difícil en terreno: categoria_provisional = Sí es respuesta válida y preferible a adivinar.",
    },
    {
        id: "DES-06",
        caso: "Cerámica de muro suelta en el baño",
        etiquetaAmbigua: "SAN (porque está en el baño)",
        categoriaCorrecta: "REV-06 (cerámica de muro). Tipo de observación TF-03.",
        porQue: "El recinto no determina la categoría. Para eso está el eje Ubicación.",
    },
    {
        id: "DES-07",
        caso: "Puerta que roza el piso",
        etiquetaAmbigua: "PVE o PAV",
        categoriaCorrecta: "PVE-01 (hoja de puerta) por defecto: es un ajuste de carpintería.",
        porQue: "Sólo pasa a PAV/IMP si el piso está deformado por humedad, y en ese caso la puerta es daño derivado.",
    },
    {
        id: "DES-08",
        caso: "Vidrio con salpicaduras de mortero o protecciones sin retirar",
        etiquetaAmbigua: "TER-01 (aseo de entrega) en v1",
        categoriaCorrecta: "PVE-03 (cristal) + TF-18 (Aseo).",
        porQue: "TER desapareció: el aseo viaja como tipo de observación sobre el elemento efectivamente sucio.",
    },
    {
        id: "DES-09",
        caso: "Falta el tope de la puerta",
        etiquetaAmbigua: "TER-02 (elemento faltante) en v1",
        categoriaCorrecta: "PVE-04 (quincallería) + TF-10 (Elemento faltante).",
        porQue: "Mismo criterio: el faltante es un tipo de observación, no una especialidad.",
    },
    {
        id: "DES-10",
        caso: "Grieta en el muro del hall del edificio",
        etiquetaAmbigua: "COM-01 (hall) en v1",
        categoriaCorrecta: "EST-02 o REV-03 según el elemento. Ubicación = RC-16 (Hall / lobby), Ámbito = Común.",
        porQue: "COM desapareció: el ámbito común es una UBICACIÓN, no un gremio.",
    },
    {
        id: "DES-11",
        caso: "Tablero eléctrico mojado",
        etiquetaAmbigua: "En v1 no era codificable: la matriz no permitía humedad en ELE",
        categoriaCorrecta: "ELE-01 (tablero) + TF-04. Dispara P1 → S1.",
        porQue: "Era el ejemplo estrella de S1 de la propia planilla y la matriz de validez lo bloqueaba.",
    },
    {
        id: "DES-12",
        caso: "Olor a gas en la cocina",
        etiquetaAmbigua: "En v1 caía forzadamente en «sello deficiente» u «operación deficiente»",
        categoriaCorrecta: "GAS-01 (red de gas) o GAS-02 (artefacto) + TF-04 (fuga). Dispara P1 → S1.",
        porQue: "TF-04 se amplió explícitamente para cubrir fugas de gas.",
    },
    {
        id: "DES-13",
        caso: "«Techo» a secas en la voz del inspector",
        etiquetaAmbigua: "EL-02 (Cielo), EL-10 (Cubierta) o RC-23 (Techumbre / azotea)",
        categoriaCorrecta: "EL-02 (Cielo) si el recinto es interior de la unidad o un espacio común techado. EL-10 (Cubierta) sólo si el recinto es RC-23 o la observación mira la cubierta desde afuera. «Cielo raso», «cielo falso» y «losa de cielo» son siempre EL-02; «techumbre», «cubierta» y «tejado» son siempre EL-10.",
        porQue: "En es-CL coloquial «techo» es el cielo interior; en vocabulario de obra «techumbre» es la cubierta. Además cruza ejes: RC-23 es un RECINTO, no un elemento. Desempata el recinto, no la palabra.",
    },
    {
        id: "DES-14",
        caso: "Cornisa dañada",
        etiquetaAmbigua: "EL-01 (Muro) o EL-02 (Cielo)",
        categoriaCorrecta: "Cornisa interior de yeso en el encuentro muro-cielo: EL-02 (Cielo), porque la repara el gremio del cielo. Cornisa exterior o moldura de fachada: EL-01 (Muro), con recinto RC-15 (Fachada de la unidad).",
        porQue: "La cornisa vive en el encuentro de dos elementos y ninguno la describe solo, así que el criterio es el mismo que la regla de oro del eje Categoría: quién la repara. Un alias de sinónimos no puede resolverlo — fijaría por decreto una ambigüedad real y convertiría un null que retiene correctamente en un código incorrecto que cierra el gate.",
    },
    // DES-15..18 (2026-10-08, ADR-0135) — desempatan el eje Ubicación, no
    // el de Categoría, igual que DES-10 y DES-13: un recinto que existe
    // dentro de la unidad y en el edificio vive en DOS filas, y lo que elige
    // la fila es el ámbito que dice el texto, no la palabra del recinto.
    {
        id: "DES-15",
        caso: "«Quincho» en la voz del propietario o del inspector",
        etiquetaAmbigua: "RC-19 (Sala multiuso / quincho común) o RC-26 (Quincho de la unidad)",
        categoriaCorrecta: "RC-19 sólo si el texto lo ubica en el espacio común: «común», «del condominio», «del edificio». En cualquier otro caso —«mi quincho», «el quincho de la casa» o «el quincho» a secas dentro de una unidad— RC-26.",
        porQue: "En una casa el quincho es parte de la unidad; en un edificio suele ser un espacio común. Desempata el ámbito que dice el texto, no la palabra «quincho».",
    },
    {
        id: "DES-16",
        caso: "«Jardín», «patio», «antejardín» o «área verde»",
        etiquetaAmbigua: "RC-22 (Área verde / paisajismo) o RC-27 (Patio / jardín de la unidad)",
        categoriaCorrecta: "RC-22 sólo si el texto lo ubica en el espacio común: «común», «del condominio», «del edificio», «áreas verdes». En cualquier otro caso —patio, antejardín o jardín de la casa— RC-27.",
        porQue: "Mismo criterio que DES-15: el ámbito lo dice el texto, no el sustantivo.",
    },
    {
        id: "DES-17",
        caso: "«Escalera»",
        etiquetaAmbigua: "RC-17 (Pasillo / escalera común) o RC-31 (Escalera interior)",
        categoriaCorrecta: "RC-17 si es la escalera del edificio o del condominio (caja de escala, escalera de emergencia). RC-31 si es la escalera dentro de la unidad: casa de dos pisos, dúplex.",
        porQue: "La escalera interior es parte de la unidad y la repara la postventa del propietario; la común es del edificio.",
    },
    {
        id: "DES-18",
        caso: "«Entretecho», «altillo» o «techumbre»",
        etiquetaAmbigua: "RC-23 (Techumbre / azotea) o RC-28 (Entretecho / altillo)",
        categoriaCorrecta: "RC-28 si es el espacio bajo la cubierta de la propia unidad: entretecho o altillo de la casa. RC-23 si es la techumbre o la azotea del edificio. «Techumbre» de una casa: RC-28 como recinto y EL-10 (Cubierta) como elemento.",
        porQue: "Complementa DES-13: el elemento lo fija la palabra, el recinto lo fija de quién es el espacio.",
    },
];
//# sourceMappingURL=desempate.js.map